import {
  Component,
  OnInit,
  OnDestroy,
  ViewContainerRef,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { DndDropEvent } from 'ngx-drag-drop';
import { UUID } from 'angular2-uuid';
import * as _ from 'lodash';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { GeneratedCodeModalComponent } from './generated-code-modal/generated-code-modal.component';
import { FormBuilderService } from './form-builder-service.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { ButtonEditCopyRendererComponent } from '../components/button-edit-copy-render.components';
import { FormBuilderUDFService } from '../services/form-builder-udf-service';
import { LanguageService } from '../services/language-service';
import { TranslaterService } from '../services/translater.service';
import { UserManagementService } from '../services/usermanagement.service';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';
import socialIcons from '../shared/drag-drop-content/elements/social-property/social-icons';
import { ComponentSettingInterface } from '../shared/drag-drop-content/interfaces/component-setting.interface';
import { ElementInterface } from '../shared/drag-drop-content/interfaces/element.interface';
import { FormInterface } from '../shared/drag-drop-content/interfaces/form.interface';
import { I18nService } from '../shared/i18n.service';
import { PreviewHtmlComponent } from '../shared/preview-html/preview-html.component';
import { BaseApi } from 'src/backend/api/base-api';
import { ColDef } from 'ag-grid-enterprise';
import { ButtonEditViewDeleteRendererComponent } from '../components/button-edit-delete-view-render.components';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSelectChange } from '@angular/material/select';

interface User {
  userCode: string;
  fullName: string;
};
interface Workflow {
  id: number;
  formId: number;
  formName: string;
  workflowName: string;
  approvalLevels: { approvers: number[] }[];
}
@Component({
  selector: 'app-form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.scss'],
})
export class FormBuilderComponent implements OnInit, OnDestroy {
  @ViewChild('popover') popover!: NgbPopover;
  @ViewChild('SaveFormPoup') private saveFormPopup!: TemplateRef<any>;
  @ViewChild('FormDetailPopup') private formDetailPopup!: TemplateRef<any>;
  @ViewChild('ApprovalPopup') private approvalPopup!: TemplateRef<any>;
  @ViewChild('ViewApproversDialog') private viewApproversDialog!: TemplateRef<any>;

  usersList: User[] = [];
  workflows: Workflow[] = [];
  filteredUsers: User[] = [];

  /**
   * Array for containing dropped components in a form
   */
  addedComponents!: Array<ElementInterface>;

  /**
   * Object for containing drag & drop form
   */
  subscriptionForm: FormInterface = {
    content_dnd: {
      added_components: [],
      form_design: {
        fullWidth: false,
        width: 600,
        page_alignment: 'top',
        background_color: '#f5f5f5',
        container_background_color: '#ffffff',
        text_color: '#000000',
        font_family: "'Helvetica Neue', Helvetica, sans-serif",
        font_size: 16,
        rounded_corners: 8,
        page_paddings: 15,
        form_paddings: 15,
        field_rounded_corners: 5,
        form_border_width: 1,
        form_border_color: '#ced4da',
        field_background_color: '#ffffff',
        field_border_width: 1,
        field_border_color: '#ced4da',
        label_font_color: '#000000',
        label_font_size: 14,
        label_font_bold: false,
        label_font_italic: false,
        field_size: 'm',
      },
    },
  };

  /**
   * Property for containing which tab is activated
   * 1: Current Element
   * 2: Form Design
   */
  public activeTab = 2;

  /**
   * Array for containing only section components
   */
  public sectionComponents: Array<ElementInterface> = [];

  /**
   * Array for containing components except section component
   */
  public components: Array<ElementInterface> = [];

  /**
   * Property for containing class name when dragging element
   */
  public dragStartClass: string = '';

  /**
   * Object for containing current selected component
   */
  public selectedComponent!: null | ElementInterface;

  /**
   * Object for containing component setting properties
   */
  protected componentSettings: ComponentSettingInterface = {
    background_color: '',
    rounded_corners: 0,
    padding_top: 10,
    padding_right: 0,
    padding_bottom: 10,
    padding_left: 0,
    height: 0,
  };

  /**
   * Current language ISO code
   */
  public currentLanguage: string = '';
  breadcrumList: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  lang: any;
  saveform!: FormGroup;
  DetailFrom!: FormGroup;
  ApprovalForm!: FormGroup;
  filteredModules: any[] = [];
  filteredPages: any[] = [];
  filteredPagesApproval: any[] = [];
  filteredSubModules: any[] = [];
  moduleList!: any[];
  pageList!: any[];
  pageListApproval!: any[];
  subModuleList!: any[];
  filterPageList!: any[];
  rowDataBuilder!: any[];
  columnDefsBuilder!: any[];
  workflowDefs!: any[];
  gridApi: any;
  workflowGridApi: any;
  workflowGridColumnApi: any;
  gridColumnApi: any;
  gridOptions = {
    paginationPageSize: 5,
    infiniteInitialRowCount: 2,
    defaultColDef: {
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,  // <-- These properties are valid in defaultColDef
      autoHeight: true, // <-- & Here
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      // filterParams: { newRowsAction: 'keep' },
    },
    popupParent: document.querySelector('body'),
    // headerHeight: 150,
    // floatingFilter: true,
  };
  public frameworkComponents: any;
  formData: any;
  actionType: string;
  plantSession: any;
  formTypes: any[] = [
    { value: 'inputform', label: 'Input Form' },
    { value: 'report', label: 'Report' }
  ];
  approversView: any;
  workflowId: number = 0;
  constructor(
    public vcRef: ViewContainerRef,
    private modalService: NgbModal,
    private translate: TranslateService,
    private formBuilderService: FormBuilderService,
    private i18nService: I18nService,
    private router: Router,
    private usermanagementService: UserManagementService,
    private translater: TranslaterService,
    private toaster: ToastrService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private languageService: LanguageService,
    private formService: FormBuilderUDFService, private baseApi: BaseApi, private spinner: NgxSpinnerService,
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.frameworkComponents = {
      buttonEditRenderer: ButtonEditCopyRendererComponent,
      buttonEditViewDeleteRendererComponent: ButtonEditViewDeleteRendererComponent,
    }
    this.columnDefsBuilder = [
      { headerName: 'Actions', cellRenderer: 'buttonEditRenderer', cellRendererParams: { onClick: this.onClickEdit.bind(this), label: 'Edit' }, maxWidth: 150, suppressMenu: true },
      {
        headerName: 'Form Name',
        field: 'form_name',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Plant Name',
        field: 'PT_Desc',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Page Name',
        field: 'PageText',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Created By',
        field: 'UserName',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Created On',
        field: 'created_on',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ],

      this.workflowDefs = [
        { headerName: 'Workflow Name', field: 'workflowName', headerValueGetter: this.localizeHeader.bind(this) },
        {
          headerName: 'Created On', field: 'CreatedOn', headerValueGetter: this.localizeHeader.bind(this), valueFormatter: function (params: any) {
            return moment(params.value).format('MM/DD/YYYY HH:mm');
          }
        },
        { headerName: 'Actions', headerValueGetter: this.localizeHeader.bind(this), cellRenderer: 'buttonEditViewDeleteRendererComponent', cellRendererParams: { onClick: this.onButtonClick.bind(this), label: 'Edit' }, suppressMenu: true },
      ];
  }

  /**
   * On Init handler
   */
  ngOnInit() {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.getLangWords();
    this.initForm();
    this.filteredUsers = [...this.usersList];
    document.body.classList.add('drag-drop-page');

    this.currentLanguage = this.i18nService.language;

    this.sectionComponents = [
      {
        name: this.translate.instant('1 columns'),
        elementName: 'section',
        image: 'assets/col1.png',
        column: '1',
        addedComponents: new Array(1).fill([] as ElementInterface[]),
        deletable: true,
      },
      {
        name: this.translate.instant('2 columns'),
        elementName: 'section',
        image: 'assets/col2.png',
        column: '2',
        addedComponents: new Array(2).fill([] as ElementInterface[]),
        deletable: true,
      },
      {
        name: this.translate.instant('3 columns'),
        elementName: 'section',
        image: 'assets/col3.png',
        column: '3',
        addedComponents: new Array(3).fill([] as ElementInterface[]),
        deletable: true,
      },
      {
        name: this.translate.instant('4 columns'),
        elementName: 'section',
        image: 'assets/col4.png',
        column: '4',
        addedComponents: new Array(4).fill([] as ElementInterface[]),
        deletable: true,
      },
      {
        name: this.translate.instant('5 columns'),
        elementName: 'section',
        image: 'assets/col5.png',
        column: '5',
        addedComponents: new Array(5).fill([] as ElementInterface[]),
        deletable: true,
      }, {
        name: this.translate.instant('6 columns'),
        elementName: 'section',
        image: 'assets/col6.png',
        column: '6',
        addedComponents: new Array(6).fill([] as ElementInterface[]),
        deletable: true,
      },
      {
        name: this.translate.instant('2 Columns (2:1)'),
        elementName: 'section',
        image: 'assets/col2-1-3.png',
        column: '2-1-3',
        addedComponents: new Array(2).fill(<ElementInterface[]>[]),
        deletable: true,
      },
      {
        name: this.translate.instant('2 Column (1:2)'),
        elementName: 'section',
        image: 'assets/col2-3-1.png',
        column: '2-3-1',
        addedComponents: new Array(2).fill([] as ElementInterface[]),
        deletable: true,
      },
    ];

    this.components = [
      {
        name: this.translate.instant('Button'),
        elementName: 'button',
        iconClass: 'fas fa-square fa-2x custom-icon',
        addedComponents: [],
        element: {
          content: 'Button',
          link_to: '',
          button_type: 'button',
          button_style: '',
          button_color: '#0143a3',
          text_color: '#FFFFFF',
          rounded_corners: 0,
          button_size_type: 'auto',
          button_size: 100,
          font_family: "'Helvetica Neue', Helvetica, sans-serif",
          font_size: 16,
          font_bold: false,
          font_italic: false,
          line_height: 1.5,
          height: 30,
          alignment: 'left',
          vertical_align: 'middle',
          box_shadow_color: '',
          gradient_top_color: '',
          gradient_bottom_color: '',
        },
        deletable: true,
        type: 'text',
      },
      {
        name: this.translate.instant('Input'),
        elementName: 'input',
        iconClass: 'far fa-square fa-2x custom-icon',
        addedComponents: [],
        element: {
          label: 'Input label',
          field_name: null,
          formControlName: null,
          is_required: false,
          show_label: true,
          placeholder_text: 'Placeholder text',
        },
        deletable: true,
        type: 'text',
      },
      {
        name: this.translate.instant('Textarea'),
        elementName: 'textarea',
        iconClass: 'far fa-window-maximize fa-2x custom-icon',
        addedComponents: [],
        element: {
          label: 'Textarea label',
          field_name: null,
          formControlName: null,
          is_required: false,
          show_label: true,
          placeholder_text: 'Placeholder text',
        },
        deletable: true,
      },
      {
        name: this.translate.instant('Dropdown'),
        elementName: 'dropdown',
        iconClass: 'far fa-caret-square-down fa-2x custom-icon',
        addedComponents: [],
        element: {
          label: 'Dropdown label',
          options: [
            {
              id: UUID.UUID(),
              text: this.translate.instant('Option') + ' 1',
              value: this.translate.instant('Value') + ' 1',
              is_selected: true,
            },
            {
              id: UUID.UUID(),
              text: this.translate.instant('Option') + ' 2',
              value: this.translate.instant('Value') + ' 2',
              is_selected: false,
            },
            {
              id: UUID.UUID(),
              text: this.translate.instant('Option') + ' 3',
              value: this.translate.instant('Value') + ' 3',
              is_selected: false,
            },
          ],
          is_required: false,
          formControlName: null,
          OnChangeMethodName: null,
          show_label: true,
          field_name: null,
          datasourceUrl: null,
          datasourceParamaters: null,
          resultsetName: null,
          resultsetfieldName: null,
          datasource: null,
          apiEndpoint: null
        },
        deletable: true,
      },
      {
        name: this.translate.instant('Radio buttons'),
        elementName: 'radios',
        iconClass: 'fas fa-list-ul fa-2x custom-icon',
        addedComponents: [],
        element: {
          label: 'Radio buttons label',
          options: [
            {
              id: UUID.UUID(),
              text: this.translate.instant('Option') + ' 1',
              value: this.translate.instant('Value') + ' 1',
              is_selected: true,
            },
            {
              id: UUID.UUID(),
              text: this.translate.instant('Option') + ' 2',
              value: this.translate.instant('Value') + ' 2',
              is_selected: false,
            },
            {
              id: UUID.UUID(),
              text: this.translate.instant('Option') + ' 3',
              value: this.translate.instant('Value') + ' 3',
              is_selected: false,
            },
          ],
          is_required: false,
          formControlName: null,
          show_label: true,
          field_name: null,
        },
        deletable: true,
      },
      {
        name: this.translate.instant('Checkbox'),
        elementName: 'checkbox',
        iconClass: 'far fa-check-square fa-2x custom-icon',
        addedComponents: [],
        element: {
          label: 'Checkbox label',
          field_name: null,
          is_required: false,
          formControlName: null,
          OnChangeMethodName: null
        },
        deletable: true,

      },
      {
        name: this.translate.instant('Text'),
        elementName: 'text',
        iconClass: 'fas fa-language fa-2x custom-icon',
        addedComponents: [],
        element: {
          content:
            '<p>New Text Section</p>\
          <p>Click in the section and start typing to add content.</p>',
          line_height: 1.5,
          text_color: null,
          formControlName: null,
          OnChangeMethodName: null,
          font_family: "'Helvetica Neue', Helvetica, sans-serif",
        },
        deletable: true,
      },
      {
        name: this.translate.instant('Picture'),
        elementName: 'picture',
        iconClass: 'far fa-image fa-2x custom-icon',
        addedComponents: [],
        element: {
          image_url: '',
          image_link: '',
          alignment: 'center',
          alt_text: '',
          width: 0,
        },
        deletable: true,
      },
      {
        name: this.translate.instant('Spacer'),
        elementName: 'spacer',
        iconClass: 'fas fa-arrows-alt-v fa-2x custom-icon',
        addedComponents: [],
        element: {
          height: 30,
        },
        deletable: true,
      },
      {
        name: this.translate.instant('Separator'),
        elementName: 'separator',
        iconClass: 'fas fa-grip-lines fa-2x custom-icon',
        addedComponents: [],
        element: {
          border_style: 'solid',
          border_color: '',
          border_width: 1,
          orientation: 'horizontal',
          height: 100
        },
        deletable: true,
      },
      {
        name: this.translate.instant('Social'),
        elementName: 'social',
        iconClass: 'fas fa-share-alt fa-2x custom-icon',
        addedComponents: [],
        element: {
          icon_size: '32px',
          alignment: 'left',
          placement: 'horizontally',
        },
        buttons: [
          { ...socialIcons[0], id: UUID.UUID() },
          { ...socialIcons[1], id: UUID.UUID() },
          { ...socialIcons[2], id: UUID.UUID() },
          { ...socialIcons[3], id: UUID.UUID() },
          { ...socialIcons[4], id: UUID.UUID() },
        ],
        deletable: true,
      },
      {
        name: this.translate.instant('Uploader'),
        elementName: 'uploader',
        iconClass: 'fas fa-upload fa-2x custom-icon',
        addedComponents: [],
        element: {
          field_name: null,
          upload_url: 'https://example.com/upload-handler',
          accepted_files: 'image/*',
          max_file_size: 2,
          placeholder: this.translate.instant(
            'Click or drag images here to upload'
          ),
          line_height: 1.5,
          text_color: null,
          font_family: "'Helvetica Neue', Helvetica, sans-serif",
          font_size: 16,
          border_style: 'dashed',
          border_color: '#c7c3c3',
          border_width: 3,
          width_type: 'full-width',
          width: 150,
          alignment: 'center',
        },
        deletable: true,
      },
      {
        name: this.translate.instant('List'),
        elementName: 'list',
        iconClass: 'fa fa-list fa-2x custom-icon',
        addedComponents: [],
        element: {
          label: 'List',
          columnDefs: [
            {
              headerName: '',
              field: '',
              editable: true,
              sortable: true,
              resizable: true,
              filter: true,
              cellEditor: '',
              cellEditorParams: {
                values: []
              },

            }

          ],
          is_required: false,
          formControlName: null,
          OnChangeMethodName: null,
          show_label: true,
          field_name: null,
          datasourceUrl: null,
          datasourceParamaters: null,
          buttonDelete: true,
          buttonEdit: true,
          listtype: '',
          tableName: null,
          apiEndpoint: null,
          datasource: null

        },
        deletable: true,
      },
    ];
  }
  initForm() {
    this.saveform = this.formBuilder.group({
      formName: ['', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9 ]*$/)
      ]],
      formType: [''],
      pageType: ['', Validators.required],
      formSourceCode: [],
      page: ['', Validators.required],
      submodule: [],
      module: []
    });

    this.DetailFrom = this.formBuilder.group({
      page: [],
      submodule: [],
      module: []
    });

    this.ApprovalForm = this.formBuilder.group({
      page: ['', Validators.required],
      approvalLevels: this.formBuilder.array([
        this.createLevelForm()
      ])
    });

  }

  createLevelForm(): FormGroup {
    return this.formBuilder.group({
      approvers: [[], Validators.required]
    });
  }
  /**
   * On destroy handler
   */
  ngOnDestroy() {
    document.body.classList.remove('drag-drop-page');
  }

  /**
   * On preview handler
   */
  onPreview() {
    const modalRef = this.modalService.open(PreviewHtmlComponent, {
      size: 'lg',
      windowClass: 'full-width',
      centered: true,
      scrollable: false,
    });
    this.formBuilderService.components =
      this.subscriptionForm.content_dnd.added_components;
    this.formBuilderService.formDesign =
      this.subscriptionForm.content_dnd.form_design;

    modalRef.componentInstance.content = this.formBuilderService.generateHtml();
  }

  /**
   * On drag start event handler
   *
   * @param event
   */
  onDragStart(event: DragEvent) {
    this.dragStartClass = 'bg-light';
  }

  /**
   * On dragged event handler
   *
   * @param item
   * @param list
   * @param effect
   */
  onDragged(
    item: ElementInterface,
    list: Array<ElementInterface>,
    effect: string
  ) {
    if (effect === 'move') {
      const index = list.findIndex((i: any) => {
        if (item.id && item.id === i.id) {
          return true;
        }

        return false;
      });

      list.splice(index, 1);
    }
  }

  /**
   * On drag end event handler
   *
   * @param event
   */
  onDragEnd(event: DragEvent) {
    this.dragStartClass = '';
  }

  /**
   * On dropped event hanlder
   *
   * @param event
   * @param list
   * @returns
   */
  onDrop(event: DndDropEvent, list: Array<ElementInterface>) {
    this.closePopover();

    if (['copy', 'move'].indexOf(event.dropEffect) === -1) {
      return false;
    }

    let index = event.index;

    if (typeof index === 'undefined') {
      index = list.length;
    }

    // Reset selected state
    this.resetAllSelectedState();

    const component = _.clone(event.data);
    component.isSelected = true;
    component.id = UUID.UUID();

    if (
      [
        'radios',
        'dropdown',
        'input',
        'checkbox',
        'textarea',
        'uploader',
      ].includes(component.elementName)
    ) {
      component.element.field_name = `${component.elementName}_label`;
      component.element.formControlName = `${component.elementName}-${component.id.split('-').shift()}`;

      component.element.OnChangeMethodName = `${component.element.OnChangeMethodName}`;
    }

    if (
      component.elementName === 'radios' ||
      component.elementName === 'dropdown'
    ) {
      for (let option of component.element.options) {
        option.id = UUID.UUID();
      }
    }

    if (!component.hasOwnProperty('componentSettings')) {
      component.componentSettings = _.clone(this.componentSettings);
    }

    this.selectedComponent = component;
    list.splice(index, 0, component);

    this.activeTab = 1;

    return true;
  }

  /**
   * Set component as selected
   *
   * @param $event
   * @param component
   */
  setSelectedComponent($event: any, component: ElementInterface) {
    $event.stopPropagation();
    this.resetAllSelectedState();
    component.isSelected = true;
    this.selectedComponent = component;

    this.activeTab = 1;
  }

  /**
   * Reset all selected elements's state
   */
  resetAllSelectedState() {
    this.subscriptionForm.content_dnd.added_components.forEach((c: any) => {
      c.isSelected = false;

      if (c.addedComponents.length > 0) {
        c.addedComponents.forEach((cc: Array<any>) => {
          cc.forEach((ccc) => {
            ccc.isSelected = false;
          });
        });
      }
    });
  }

  /**
   * Delete selected component
   *
   * @param $event
   * @param id
   */
  deleteComponent($event: any, id: string) {
    $event.stopPropagation();

    const modalConfirm = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
    });

    modalConfirm.componentInstance.title = this.translate.instant(
      'Delete confirmation'
    );
    modalConfirm.componentInstance.message = this.translate.instant(
      'Are you sure, that you want to delete this element?'
    );

    modalConfirm.result.then(
      (result) => {
        if (result === 'OK_CLICK') {
          let index = -1;
          for (let c of this.subscriptionForm.content_dnd.added_components) {
            index++;
            if (c.id === id) {
              this.subscriptionForm.content_dnd.added_components.splice(
                index,
                1
              );
              break;
            }

            if (c.addedComponents.length) {
              for (let cc of c.addedComponents) {
                let cIndex = _.findIndex(cc, { id: id });

                if (cIndex > -1) {
                  cc.splice(cIndex, 1);
                  break;
                }
              }
            }
          }

          this.selectedComponent = null;
        }
      },
      (reason) => { }
    );
  }

  /**
   * Close Add section popup
   */
  closePopover() {
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
   * Generate form builder to HTML code
   *
   * @return string
   */
  generateHtml() {
    const modalRef = this.modalService.open(GeneratedCodeModalComponent, {
      size: 'lg',
    });

    this.formBuilderService.components =
      this.subscriptionForm.content_dnd.added_components;
    this.formBuilderService.formDesign =
      this.subscriptionForm.content_dnd.form_design;

    modalRef.componentInstance.title = this.translate.instant('HTML code');
    modalRef.componentInstance.content = this.formBuilderService.generateHtml();
  }

  /**
   * Generate form builder to JSON code
   *
   * @return string
   */
  generateJson() {
    const modalRef = this.modalService.open(GeneratedCodeModalComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.title = this.translate.instant('JSON code');
    modalRef.componentInstance.content = JSON.stringify(
      this.subscriptionForm.content_dnd,
      null,
      2
    );
  }

  /**
   * Change application language
   *
   * @param langCode
   */
  changeLanguage(langCode: string) {
    this.currentLanguage = langCode;
    this.i18nService.language = langCode;
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }


  public getLangWords() {
    const pageId = this.baseApi.getCurrentMenuID();
    const moduleId = this.baseApi.getUserPermissionsSession().find(x => x.menuId === pageId)?.parentId;
    const key = {
      ModuleId: moduleId,
      PageId: pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };

    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        //this.gridApi.refreshHeader();
      }
    });
  }

  openSaveModel() {
    let dialogRef = this.dialog.open(this.saveFormPopup, {
      minWidth: '60%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {
      this.getPages();

    });
    dialogRef.afterClosed().subscribe((res: any) => {
    });
  };

  public checkError = (controlName: string, errorName: string) => {
    return this.saveform.controls[controlName].hasError(errorName);
  }

  public checkErrorApproval(controlName: string, errorName: string): boolean {
    const control = this.ApprovalForm.get(controlName);
    return control ? control.hasError(errorName) && control.touched : false;
  }




  getPages(): void {
    const key = {
      plantCode: this.plantSession?.plantCode
    }
    this.formService.getPages(key).subscribe((data: any) => {
      this.pageList = data.Table;
      this.filteredPages = this.pageList.slice();
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  };



  resetForm() {
    this.saveform.reset();
  }

  saveFormData() {
    const missing = this.getMissingFieldNames();
    if (missing.length > 0) {
      const missingList = missing
        .map((m, i) => `${i + 1}. "${m.label}" (${m.elementName}) — ${m.error}`)
        .join('\n');
      this.toaster.error(
        `Please fix Field Name for:\n${missingList}`,
        'Invalid Field Name',
        {
          timeOut: 6000,
          enableHtml: false,
          disableTimeOut: missing.length > 3
        }
      );
      return;
    }

    this.generateHTMLCode();
    if (this.formData?.form_type === 'report' && this.formData?.id !== null) {
      this.saveform.get('formName').setValue('report');
    }
    if (this.saveform.valid) {
      const key = {
        Id: this.formData?.id === undefined ? 0 : this.formData?.id,
        formName: this.saveform.get('formName')?.value,
        TransactionType: this.formData?.id === undefined ? 1 : 2,
        formJson: JSON.stringify(this.subscriptionForm.content_dnd, null, 2),
        formHtml: this.formBuilderService.generateHtml(),
        pageId: this.formData?.id === undefined ? this.saveform.get('page')?.value : this.formData?.page_code,
        plantCode: this.formData?.id === undefined ? this.plantSession?.plantCode : this.formData?.plantCode,
        formType: this.saveform.get('pageType')?.value
      };
      this.formService.saveForm(key).subscribe((data: any) => {
        if (data?.Table[0]?.statusCode === 201) {
          this.toaster.success(data?.Table[0]?.message);
          this.dialog.closeAll();
          this.rowDataBuilder = [];
          this.DetailFrom.reset();
          this.resetForm();
          this.resetAllSelectedState();
        } else if (data?.Table[0]?.statusCode === 409) {
          this.toaster.error(data?.Table[0]?.message);
          this.dialog.closeAll();
          this.rowDataBuilder = [];
          this.DetailFrom.reset();
          this.resetForm();
          this.resetAllSelectedState();
        }
      }, (error: any) => {
        this.toaster.error(error.message);
      });
    }
  }

  getMissingFieldNames(): { label: string, elementName: string, error: string }[] {
    const missing: { label: string, elementName: string, error: string }[] = [];
    // Valid SQL Server column name: letters, numbers, underscore only — no spaces, no hyphens
    const validFieldName = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
    const fieldNameMap: Map<string, { label: string, elementName: string }[]> = new Map();

    const check = (elements: any[]): void => {
      elements.forEach((el: any) => {
        if (['input', 'dropdown', 'checkbox', 'textarea', 'list', 'uploader', 'radios'].includes(el.elementName)) {
          const fieldName = el.element?.field_name;
          const label = el.element?.label || el.name || el.elementName;

          if (!fieldName) {
            missing.push({ label, elementName: el.elementName, error: 'Field name is empty' });
          } else if (fieldName.includes(' ')) {
            missing.push({ label, elementName: el.elementName, error: `"${fieldName}" contains spaces` });
          } else if (fieldName.includes('-')) {
            missing.push({ label, elementName: el.elementName, error: `"${fieldName}" contains hyphens (-)` });
          } else if (!validFieldName.test(fieldName)) {
            missing.push({ label, elementName: el.elementName, error: `"${fieldName}" contains invalid characters` });
          } else {
            // Track valid field names for duplicate detection
            const key = fieldName.toLowerCase();
            if (!fieldNameMap.has(key)) {
              fieldNameMap.set(key, []);
            }
            fieldNameMap.get(key)!.push({ label, elementName: el.elementName });
          }
        }
        if (el.addedComponents && Array.isArray(el.addedComponents)) {
          el.addedComponents.forEach((sub: any) => {
            if (Array.isArray(sub)) check(sub);
          });
        }
      });
    };
    check(this.subscriptionForm.content_dnd.added_components);

    // Check for duplicate field names
    fieldNameMap.forEach((entries, fieldName) => {
      if (entries.length > 1) {
        entries.forEach(entry => {
          missing.push({
            label: entry.label,
            elementName: entry.elementName,
            error: `Field name "${fieldName}" is duplicated across ${entries.length} elements`
          });
        });
      }
    });

    return missing;
  }

  generateHTMLCode() {
    //this.saveform.get('formType')?.value === 'json' ? this.generateJson() : this.generateHtml();
    this.formBuilderService.components =
      this.subscriptionForm.content_dnd.added_components;
    this.formBuilderService.formDesign =
      this.subscriptionForm.content_dnd.form_design;
    this.formBuilderService.generateHtml();
  };

  openFormDetailModel() {
    let dialogRef = this.dialog.open(this.formDetailPopup, {
      minWidth: '60%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {
      this.getPages();
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.DetailFrom.reset();
    });
  };

  openApprovalModel() {
    let dialogRef = this.dialog.open(this.approvalPopup, {
      minWidth: '60%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {
      this.getUIBuilderPages();
      this.getUsers();
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.DetailFrom.reset();
    });
  };

  getAllForms() {
    const key = {
      pageId: this.DetailFrom.get('page')?.value,
      plantCode: this.plantSession?.plantCode,
    }
    this.formService.getFormByModuleAndPage(key).subscribe((data: any) => {
      this.rowDataBuilder = data.Table;
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  };

  //==========================Edit Form============================//
  onClickEdit(obj: any) {
    this.saveform.get('page').clearValidators();
    this.actionType = obj?.action;
    if (this.actionType === 'copyform') {
      this.formData = obj.rowData === undefined ? obj.data : obj.rowData;
      this.dialog.closeAll();
      this.openSaveModel();
    } else {
      this.formData = obj.rowData === undefined ? obj.data : obj.rowData;
      this.saveform.get('page').setValue(this.formData?.page_code);
      this.saveform.get('formName')?.patchValue(this.formData?.form_name);
      this.saveform.get('pageType')?.patchValue(this.formData?.form_type);
      this.subscriptionForm.content_dnd = JSON.parse(this.formData?.form_source_code_json);
      this.dialog.closeAll();
    }
  }

  //========================================== Copy Form===========================//

  copyFormData() {
    if (this.saveform.get('pageType')?.value === null) {
      this.toaster.error('Error', 'Please select form type');
      return;
    }
    const key = {
      Id: 0,
      formName: this.saveform.get('formName')?.value,
      formType: this.saveform.get('pageType')?.value,
      TransactionType: 1,
      formJson: this.formData?.form_source_code_json,
      formHtml: this.formData?.form_source_code_html,
      pageId: this.saveform.get('page')?.value,
      plantCode: this.plantSession?.plantCode
    };
    this.formService.saveForm(key).subscribe((data: any) => {
      this.toaster.success('success', data?.Table[0]?.Column1);
      this.dialog.closeAll();
      this.rowDataBuilder = [];
      this.DetailFrom.reset();
      this.resetAllSelectedState();

    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });

  };

  //========================================================= AG Grid ====================================================//

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onWorkflowGridReady(params: any): any {
    this.workflowGridApi = params.api;
    this.workflowGridColumnApi = params.columnApi;
  }

  //================================field validation==========================//
  blockSpecialCharacters(event: KeyboardEvent) {
    const allowedChars = /^[a-zA-Z0-9 ]$/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  //==================================Get Users List==================================//
  getUsers(): void {
    this.spinner.show();
    this.usermanagementService.getUserbyPlant().subscribe({
      next: (data: any) => {
        this.usersList = data;
        this.filteredUsers = this.usersList.slice();
        this.spinner.hide();
      },
      error: (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    });
    this.spinner.hide();
  }

  /*======================================Approval code====================================*/

  getUIBuilderPages(): void {
    const key = {
      plantCode: this.plantSession?.plantCode
    }
    this.formService.getUIBuilderPages(key).subscribe((data: any) => {
      this.pageListApproval = data.Table;
      this.filteredPagesApproval = this.pageListApproval.slice();
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  };

  closeApprovalModel() {
    this.ApprovalForm.reset();
    this.approvalLevels.clear();
    this.workflows = [];
    this.approvalLevels.push(this.createLevelForm());
    this.dialog.closeAll();
  }

  onButtonClick(e: any) {
    const actionType = e?.action;
    const data = e?.rowData === undefined ? e.data : e?.rowData;
    if (actionType === 'edit') {
      this.editWorkflow(data);
    } else if (actionType === 'view') {
      this.openViewApproversDialog(data?.approvalLevels);
    } else if (actionType === 'delete') {
      this.deleteWorkflow(data);
    }
  }

  /** GET APPROVAL LEVEL ARRAY */
  get approvalLevels(): FormArray {
    return this.ApprovalForm.get('approvalLevels') as FormArray;
  }

  /** ADD NEW APPROVAL LEVEL */
  addApprovalLevel(): void {
    this.approvalLevels.push(this.createLevelForm());
  }

  /** REMOVE APPROVAL LEVEL */
  removeApprovalLevel(index: number): void {

    if (this.approvalLevels.length > 1) {
      this.approvalLevels.removeAt(index);
    }

  }

  isUserVisible(user: any): boolean {
    return this.filteredUsers.some(u => u.userCode === user.userCode);
  }

  selectedUsers(levelIndex: number, event: MatSelectChange): void {
    const control = this.approvalLevels.at(levelIndex).get('approvers');
    if (!control) return;

    const prev: any[] = Array.isArray(control.value) ? control.value : [];
    const selectedValue = event.value;
    let newSelection: any[];
    if (Array.isArray(selectedValue)) {
      newSelection = selectedValue;
    } else {
      newSelection = prev.includes(selectedValue)
        ? prev.filter(v => v !== selectedValue)
        : [...prev, selectedValue];
    }

    control.setValue(newSelection);
    control.updateValueAndValidity();
  }



  submitWorkflow(): void {
    if (this.ApprovalForm.valid === false) {
      this.ApprovalForm.markAllAsTouched();
      return;
    }
    if (this.workflows.length > 0 && this.workflowId === 0) {
      this.toaster.error('Error', 'Workflow already exists for this form kindly edit the existing one');
      return;
    }
    const formValue = this.ApprovalForm.value;
    const workflow: Workflow = {
      id: new Date().getTime(), // simple unique ID
      formId: formValue.page,
      formName: this.pageListApproval.find(f => f.MenuId === formValue.page)?.Label || '',
      workflowName: this.pageListApproval.find(f => f.MenuId === formValue.page)?.Label || '',
      approvalLevels: formValue.approvalLevels
    };

    // If editing existing workflow
    const existingIndex = this.workflows.findIndex(w => w.id === workflow.id);
    if (existingIndex > -1) {
      this.workflows[existingIndex] = workflow;
    } else {
      this.workflows.push(workflow);
    }
    if (this.workflowGridApi) {
      this.workflowGridApi.setRowData(this.workflows);
    }

    const key = {
      plantCode: this.plantSession?.plantCode,
      pageCode: workflow.formId,
      workflowId: this.workflowId || 0,
      workflowName: workflow.workflowName,
      approvalLevels: workflow.approvalLevels
    };
    this.spinner.show();
    this.formService.saveWorkflow(key).subscribe({
      next: (data: any) => {
        if (data?.Table[0]?.statusCode === 201 || data?.Table[0]?.statusCode === 200) {
          this.toaster.success(data?.Table[0]?.message);
          this.getWorkflows();
          this.spinner.hide();
          this.initForm();
          this.workflowId = 0;
        }
      },
      error: (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    });
  }

  getWorkflows(): void {
    this.spinner.show();
    const key = {
      plantCode: this.plantSession?.plantCode,
      pageCode: this.ApprovalForm.get('page')?.value
    }
    this.formService.getWorkflows(key).subscribe({
      next: (data: any) => {
        const workflowData = Array.isArray(data.workflowData) ? data.workflowData : [];
        const workflowsApproverData = Array.isArray(data.workflowsApproverData) ? data.workflowsApproverData : [];
        this.workflows = workflowData.map((wf: any) => ({
          id: wf.WorkflowId,
          formId: wf.PageCode,
          // formName: wf.FormName,
          workflowName: wf.WorkflowName,
          CreatedOn: wf.CreatedOn,
          approvalLevels: this.groupApproversByLevel(workflowsApproverData, wf.WorkflowId)
        }));
        this.spinner.hide();
        if (this.workflowGridApi) {
          this.workflowGridApi.setRowData(this.workflows);
        }
      },
      error: (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    });

  }
  // Edit workflow from AG Grid
  editWorkflow(workflow: Workflow): void {
    this.workflowId = workflow.id;
    this.ApprovalForm.patchValue({
      page: workflow.formId
    });

    const levelsFA = this.ApprovalForm.get('approvalLevels') as FormArray;
    levelsFA.clear();

    workflow.approvalLevels.forEach(lvl => {
      levelsFA.push(this.formBuilder.group({
        approvers: [lvl.approvers, Validators.required]
      }));
    });
  }

  // View approvers
  viewApprovers(approvalLevels: { approvers: number[]; levelNumber?: number }[]): { level: number; approvers: string[] }[] {
    if (!approvalLevels || approvalLevels.length === 0) {
      return [];
    }
    return approvalLevels.map((level, index) => {
      const levelNum = level.levelNumber || index + 1;
      const approverNames = level.approvers
        .map(id => this.usersList.find(u => u.userCode === id.toString())?.fullName)
        .filter(Boolean) as string[];
      return {
        level: levelNum,
        approvers: approverNames.length > 0 ? approverNames : ['No approvers']
      };
    });
  }

  // Group approvers by level for a specific workflow
  groupApproversByLevel(workflowApproverData: any[], workflowId: number): { approvers: string[]; levelNumber: number }[] {
    const filteredApprovers = workflowApproverData.filter((approver: any) => approver.WorkflowId === workflowId);
    const groupedByLevel: { [key: number]: string[] } = {};

    filteredApprovers.forEach((approver: any) => {
      const level = approver.LevelNumber || 1;
      if (!groupedByLevel[level]) {
        groupedByLevel[level] = [];
      }
      groupedByLevel[level].push(approver.ApproverUserId);
    });

    return Object.keys(groupedByLevel)
      .sort((a, b) => Number(a) - Number(b))
      .map(level => ({
        approvers: groupedByLevel[Number(level)],
        levelNumber: Number(level)
      }));
  }

  // Open dialog to view approvers
  openViewApproversDialog(approvalLevels: any): void {
    this.approversView = null;
    this.approversView = this.viewApprovers(approvalLevels);
    const dialogRef = this.dialog.open(this.viewApproversDialog, {
      minWidth: '30%',
      minHeight: '20%',
    });
  }
  // Delete workflow
  deleteWorkflow(workflow: Workflow): void {
    const modalConfirm = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
    });

    modalConfirm.componentInstance.title = this.translate.instant(
      'Delete confirmation'
    );
    modalConfirm.componentInstance.message = this.translate.instant(
      'Are you sure, that you want to delete this workflow?'
    );

    modalConfirm.result.then(
      (result) => {
        if (result === 'OK_CLICK') {
          const key = {
            workflowId: workflow.id
          };
          this.spinner.show();
          this.formService.deleteWorkflow(key).subscribe({
            next: (data: any) => {
              if (data?.workflowData[0]?.statusCode === 200) {
                this.toaster.success(data?.workflowData[0]?.message);
                this.getWorkflows();
                this.spinner.hide();
              }
            },
            error: (error: any) => {
              this.toaster.error('error', error.message);
              this.spinner.hide();
            }
          });
        }
      }
    );
  }
}
